export const meta = {
  name: 'Admin',
  title: 'Admin Dashboard',
};
